module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_html.js
// module id = 126
// module chunks = 58